module.exports = __webpack_public_path__ + "static/media/bannerTablet@2x.e7b534e3.png";